import { isLoggedIn, logout, push_history } from '@acri-tools/react-tools/utils';
import classNames from 'classnames';
import React,{Component} from 'react';
import { connect } from 'react-redux';
import { keycloak_logout } from '../../utils/authentication';
import DialogModal from '../DialogModal/DialogModal';
import './TopBarLogin.css';

interface Props{

    // redux
    login: any
}

interface State{
    open_dialog?: boolean
}


export default connect((state: any)=>{
    return {
        login: state.login
    }
})(class TopBarLogin extends Component<Props, State>{
    state = {
        open_dialog: false
    }
    render(){
        return (
            <>
                <div
                    className={classNames({
                        "top-bar-login": true,
                    })} 
                >
                    {
                        isLoggedIn() ?
                            <>
                                {
                                    this.state.open_dialog &&
                                    <DialogModal
                                        open={true}
                                        title={<span> <i className="fas fa-power-off"/> Logout</span>}
                                        message={<>
                                            <div className="logout-warning">
                                                <i className="fas fa-exclamation-triangle"/> Attention
                                            </div>
                                            <div className="logout-message">
                                                You are about to logout, would you like to logout from keycloak as well ?
                                            </div>
                                        </>}
                                        on_yes={async()=>{
                                            await logout();
                                            // logout from keycloak too
                                            keycloak_logout();
                                            this.setState({ open_dialog: false });
                                        }}
                                        on_no={async()=>{
                                            await logout();
                                            this.setState({ open_dialog: false });
                                        }}
                                        on_cancel={()=>{
                                            this.setState({ open_dialog: false });
                                        }}
                                    />
                                }
                                <div className="tb-login">

                                    <div className="tb-login-message">
                                        Logged in as
                                    </div>
                                    <div className="tb-login-user">
                                        { this.get_user_name() }
                                    </div>
                                </div>
                                <div 
                                    className="custom-button small rounded red"
                                    onClick={()=>{
                                        this.setState({ open_dialog: true })
                                    }}
                                >
                                    <i className="fas fa-power-off"/>
                                    Logout
                                </div>
                            </>
                        :
                            <>
                                <div 
                                    className="custom-button small rounded blue"
                                    onClick={()=>{
                                        push_history('/login')
                                    }}
                                >
                                    <i className="fas fa-user"/>
                                    Login
                                </div>
                            </>
                    }
                </div>
            </>
        );
    }

    get_user_name = () =>{
        console.log("login",this.props.login);
        let { user } = this.props.login;
        if(user){
            if(user.firstname && user.lastname){
                return `${user.firstname} ${user.lastname}`
            }
            else return user.username || user.email;
        }
        return;
    }
})

